var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"sub"}},[_c('div',{staticClass:"w clearfix"},[_c('div',{staticClass:"left"},_vm._l((_vm.leftText),function(val){return _c('div',{staticClass:"left-content"},[_vm._v("\n\t\t\t\t"+_vm._s(val)+"\n\t\t\t")])})),_vm._v(" "),_vm._l((_vm.imgArr),function(val){return _c('div',{staticClass:"imgContent"},[_c('a',{attrs:{"href":"javascript:;","title":""}},[_c('img',{attrs:{"src":val,"alt":""}})])])})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ec22ef0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sub.vue
// module id = 33
// module chunks = 0